import * as go from 'gojs';
import { PanelNames } from './panelNames';
import {
  selectionBorderBinding,
  selectionColorBinding,
} from './selectionAdornment';
import type { Size } from './types';
import { defaultNodeSize } from './types';
import type { CrusherNodeData } from '../../../types';

const $ = go.GraphObject.make;

export const rowColumnDefinition = () => [
  $(go.RowColumnDefinition, { row: 0, alignment: go.Spot.Top }),
  $(go.RowColumnDefinition, { row: 2, alignment: go.Spot.Bottom }),
];

export const locationBinding = () =>
  new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(
    go.Point.stringify,
  );

export const bodyPanel = () => ({
  row: 1,
  column: 1,
  name: 'BODY',
  stretch: go.GraphObject.Fill,
});

export const roundedRectangleShape = (size: Size) =>
  $(
    go.Shape,
    'RoundedRectangle',
    {
      name: PanelNames.UNIT_NODE_SELECTION_SHAPE,
      strokeWidth: 1,
      parameter1: 8,
    },
    new go.Binding('width', '', (data: CrusherNodeData) =>
      data?.useHighBin ? defaultNodeSize.tall.width : size.width,
    ),
    new go.Binding('height', '', (data: CrusherNodeData) =>
      data?.useHighBin ? defaultNodeSize.tall.height : size.height,
    ),
    selectionColorBinding(),
    selectionBorderBinding(),
  );
